import React from "react";
import { Dropdown, Nav, Navbar } from "react-bootstrap";
import { NavLink } from "react-router-dom";
import { TO_QUOTE_CREATE, TO_QUOTE_LIST } from "../../../helpers/constants";
import { getUser, logout } from "../../../helpers/utility";
import "./header.scss";

const Header = () => {
    const user = getUser();
    const displayName = user
        ? [user.firstname, user.lastname].filter(Boolean).join(" ") || user.email
        : "External user";
    const initials = user
        ? [user.firstname, user.lastname].filter(Boolean).map((value) => value.charAt(0)).join("").slice(0, 2).toUpperCase() || "EU"
        : "EU";

    return (
        <Navbar className="workspace-header" expand="md">
            <NavLink className="workspace-brand" to={TO_QUOTE_LIST} aria-label="BlueSky quotes home">
                <img src={require("../../../assets/images/logo.png")} alt="" />
                <strong>BlueSky</strong>
            </NavLink>
            <Navbar.Toggle aria-controls="workspace-navigation" />
            <Navbar.Collapse id="workspace-navigation">
                <Nav className="workspace-nav mr-auto">
                    <NavLink exact className="workspace-nav-link" activeClassName="active" to={TO_QUOTE_LIST}>
                        <i className="fas fa-file-alt" aria-hidden="true"></i><span>Quotes</span>
                    </NavLink>
                    <NavLink className="workspace-nav-link" activeClassName="active" to={TO_QUOTE_CREATE}>
                        <i className="fa fa-plus" aria-hidden="true"></i><span>Create quote</span>
                    </NavLink>
                </Nav>
                <Dropdown alignRight className="workspace-account">
                    <Dropdown.Toggle variant="link" className="workspace-account-toggle" id="workspace-account-menu">
                        <span className="workspace-avatar" aria-hidden="true">{initials}</span>
                        <strong>{displayName}</strong>
                        <i className="fa fa-chevron-down workspace-account-chevron" aria-hidden="true"></i>
                    </Dropdown.Toggle>
                    <Dropdown.Menu className="workspace-account-menu">
                        <div className="workspace-account-summary">
                            <strong>{displayName}</strong>
                            <span>{user && user.email ? user.email : "External user"}</span>
                        </div>
                        <Dropdown.Divider />
                        <Dropdown.Item as="button" onClick={logout} className="workspace-logout">
                            <i className="fa fa-sign-out" aria-hidden="true"></i><span>Sign out</span>
                        </Dropdown.Item>
                    </Dropdown.Menu>
                </Dropdown>
            </Navbar.Collapse>
        </Navbar>
    );
};

export default Header;
